import { render, staticRenderFns } from "./zhuzhi.vue?vue&type=template&id=5e6eede8&"
import script from "./zhuzhi.vue?vue&type=script&lang=ts&"
export * from "./zhuzhi.vue?vue&type=script&lang=ts&"
import style0 from "./zhuzhi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports